export default __webpack_public_path__ + "static/image--blank-01-c182198c58bb1667e8748b8a2ece8805.jpg";